import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿En qué formato vienen las planillas?',
  a: 'Todas las planillas vienen en formato .xlsx (Excel) y también incluimos los enlaces directos para copiarlas a tu Google Sheets. Podés usar el formato que te resulte más cómodo.'
}, {
  q: '¿Son editables y personalizables?',
  a: 'Sí, 100% editables. Podés cambiar colores, agregar tu logo, modificar textos y adaptar cualquier fórmula a tu método de trabajo.'
}, {
  q: '¿Sirven para presentar en obras sociales?',
  a: 'Absolutamente. Los modelos de informes y evoluciones están diseñados siguiendo los estándares requeridos por la mayoría de las obras sociales y prepagas en Argentina.'
}, {
  q: '¿Necesito algún software especial?',
  a: 'No. Solo necesitás tener instalado Microsoft Excel en tu computadora o tener una cuenta gratuita de Google (Gmail) para usar Google Sheets.'
}, {
  q: '¿Sirve si recién me recibo?',
  a: 'Es ideal para recién recibidos. Te ahorra meses de prueba y error armando tus propios sistemas y te da una estructura profesional desde tu primer paciente.'
}, {
  q: '¿Cómo accedo al material después de comprar?',
  a: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un mail con un enlace único para descargar todos los tomos y bonos directamente a tu computadora.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-gray-50" data-id="element-70">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-71">
        <div className="text-center mb-12" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-73">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-74">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-75">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-76">
                  <span className="font-bold text-gray-900 pr-8" data-id="element-77">{faq.q}</span>
                  {isOpen ? <Minus className="text-nutri-medium flex-shrink-0" size={20} data-id="element-78" /> : <Plus className="text-gray-400 flex-shrink-0" size={20} data-id="element-79" />}
                </button>

                <AnimatePresence data-id="element-80">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-81">
                      <div className="px-6 pb-6 text-gray-600 leading-relaxed" data-id="element-82">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}